import React, { useEffect, useState } from "react";
import {
  createColumnHelper,
  flexRender,
  getCoreRowModel,
  getSortedRowModel,
  useReactTable,
} from "@tanstack/react-table";
import productsDb from "../../../../mocks/db/products.db";
import Table, { TBody, Td, TFoot, Th, THead, Tr } from "../../../../components/ui/Table";
import Icon from "../../../../components/icon/Icon";
import { CardBody, CardHeader, CardHeaderChild, CardTitle } from "../../../../components/ui/Card";
import { TableCardFooterTemplate } from "../../../../templates/common/TableParts.template";
import TableSkeletonLoader from "../../../../components/loader/skeleton/tableSkeletonLoader";
import AddMachineModel from "../../../../components/admin/home/addMachineModel";
import Button from "../../../../components/ui/Button";
import { useNavigate } from "react-router-dom";
import WarningModal from "../../../../components/model/warningModel";
import RemoveWatchListConfirmationModel from "../model/removeWatchListConfirmation";
import { toast } from "react-toastify";
import { addWatchList } from "../../../../services/vizyBilityServices";
import ViewAssetInfoModel from "../model/viewAssetInfoModel";
import { currencyFormat } from "../../../../utils/helper";
// import { useMsal } from "@azure/msal-react"; // Azure B2C - temporarily disabled

const defaultData = [productsDb[0], productsDb[1], productsDb[2]];

const columnHelper = createColumnHelper();

const TablePartial = ({ isLoading, machineData, pagination, setPageSize, setPageIndex, handleResetPagination }) => {
  const navigate = useNavigate();
  // const { instance, accounts } = useMsal(); // Azure B2C - temporarily disabled
  const [sorting, setSorting] = React.useState([]);
  const [modalStatus, setModalStatus] = useState(false);
  const [editMachineInfo, setEditMachineInfo] = useState({});

  const [viewAssetInfo, setViewAssetInfo] = useState(false);
  const [vieAssetInfoID, setVieAssetInfoID] = useState(null);
  const azureUserInfo = localStorage.getItem("getAzureUserData")
    ? JSON.parse(localStorage.getItem("getAzureUserData") || {})
    : null;

  useEffect(() => {
    if (!viewAssetInfo) setVieAssetInfoID(null);
  }, [viewAssetInfo]);

  useEffect(() => {
    if (!modalStatus) setEditMachineInfo({});
  }, [modalStatus]);

  const columns = [
    columnHelper.accessor("AssetPictureUrl", {
      cell: (info) => (
        <div className="flex items-center justify-center">
          {info?.row?.original?.PrimaryImage?.url && (
            <img
              className="aspect-[9/12] w-14 h-14 rounded object-cover 2xl:w-20 2xl:h-20"
              src={info?.row?.original?.PrimaryImage?.url}
              alt=""
            />
          )}
        </div>
      ),
      header: "Image",
      footer: "Image",
      headerClassName: "text-center",
    }),
    columnHelper.accessor("Unit Number", {
      cell: (info) => <div className="text-sm text-center">{info?.row?.original?.UnitNumber || "-"}</div>,
      header: "Unit Number",
      footer: "Unit Number",
    }),
    columnHelper.accessor("Year", {
      cell: (info) => <div className="text-sm text-center">{info?.row?.original?.Year || "-"}</div>,
      header: "Year",
      footer: "Year",
    }),
    columnHelper.accessor("Make", {
      cell: (info) => <div className="text-sm text-center">{info?.row?.original?.MakeName || "-"}</div>,
      header: "Make",
      footer: "Make",
    }),
    columnHelper.accessor("Model", {
      cell: (info) => <div className="text-sm text-center">{info?.row?.original?.Model || "-"}</div>,
      header: "Model",
      footer: "Model",
    }),
    columnHelper.accessor("Serial Number", {
      cell: (info) => <div className="text-sm text-center">{info?.row?.original?.SerialNumber || "-"}</div>,
      header: "Serial Number",
      footer: "Serial Number",
    }),
    columnHelper.accessor("Machine SMU", {
      cell: (info) => (
        <div className="text-sm text-center">
          {info?.row?.original?.LastKnownSMU
            ? `${info?.row?.original?.LastKnownSMU} ${info?.row?.original?.SMUUnits ? info?.row?.original?.SMUUnits : "Hours"
            }`
            : "-"}
        </div>
      ),
      header: "Machine SMU",
      footer: "Machine SMU",
    }),
    columnHelper.accessor("Price", {
      cell: (info) => (
        <div className="text-sm text-center">
          {info?.row?.original?.AdvertisedPrice
            ? `${info?.row?.original?.AdvertisedCurrency
              ? info?.row?.original?.AdvertisedCurrency === "USD" ||
                info?.row?.original?.AdvertisedCurrency === "CAD"
                ? "$"
                : ""
              : ""
            }${currencyFormat(Number(info?.row?.original?.AdvertisedPrice))}`
            : "-"}
        </div>
      ),
      header: "Price",
      footer: "Price",
    }),

    columnHelper.accessor("Contact Name", {
      cell: (info) => <div className="text-sm text-center">{info?.row?.original?.ContactName || "-"}</div>,
      header: "Contact Name",
      footer: "Contact Name",
    }),

    columnHelper.accessor("Contact Email", {
      cell: (info) => <div className="text-sm text-center">{info?.row?.original?.ContactEmail || "-"}</div>,
      header: "Contact Email",
      footer: "Contact Email",
    }),
    columnHelper.accessor("Action", {
      cell: (info) => (
        <div className="text-sm flex text-center  justify-center whitespace-nowrap">
          <div
            className="text-[#FEBA06] cursor-pointer"
            onClick={() => {
              setViewAssetInfo(true);
              setVieAssetInfoID(info?.row?.original?.AssetId);
            }}
          >
            View
          </div>
          <div className="px-[5px]">|</div>
          <div
            className="text-[#0EA5E9] cursor-pointer"
            onClick={() => {
              setModalStatus(true);
              setEditMachineInfo(info?.row?.original);
            }}
          >
            Remove
          </div>
        </div>
      ),
      header: "Action",
      footer: "Action",
      size: 120,
      minSize: 120,
      meta: {
        sticky: "right",
      },
    }),
  ];

  const handleRemoveWatchList = () => {
    handelWatchList(editMachineInfo);
  };

  const table = useReactTable({
    data: machineData,
    columns,
    state: {
      sorting,
    },
    onSortingChange: setSorting,
    getCoreRowModel: getCoreRowModel(),
    getSortedRowModel: getSortedRowModel(),
    // debugTable: true,
  });

  const handelWatchList = (data) => {
    let payload = {
      assetId: data?.AssetId,
      assetAdvertisementId: data?.AssetAdvertisementId,
      contactId: azureUserInfo?.ContactId,
      // watchListItemId: data?.WatchListItemId,
      active: false,
    };

    const header = {
      authorization: `Bearer ${localStorage.getItem("vizy-bility-token")}`,
    };

    addWatchList(payload, header)
      .then((res) => {
        console.log("res", res);
        toast.success("Machine removed from your watchlist successfully!");
        setEditMachineInfo(null);
        setModalStatus(false);
        handleResetPagination();
      })
      .catch((err) => {
        toast.error(err?.data || "Something went wrong. Please try again.");
      });
  };
  return (
    <>
      <div className="flex justify-between">
        <CardHeader>
          <CardHeaderChild>
            <CardTitle>Watch List Assets</CardTitle>
          </CardHeaderChild>
        </CardHeader>
        {/* <div className="m-[14px] text-end">
          <Button
            className="!bg-[#FEBA06] border-none !text-black px-[20px] py-[12px] rounded-xl font-medium"
            onClick={() => navigate(`/admin/add-machine`)}
          >
            Add Machine
          </Button>
        </div> */}
      </div>

      <CardBody className="overflow-auto">
        <div className="overflow-x-auto">
          <Table className="min-w-[1200px]">
            <THead>
              {table.getHeaderGroups().map((headerGroup) => (
                <Tr key={headerGroup.id}>
                  {headerGroup.headers.map((header) => (
                    <Th
                      key={header?.id}
                      isColumnBorder={false}
                      className={`text-left ${header.column.columnDef.meta?.sticky === 'right' ? '!bg-gray-50 dark:!bg-[#09090b] shadow-[-4px_0_6px_-2px_rgba(0,0,0,0.3)]' : ''}`}
                      style={{
                        width: header.getSize(),
                        ...(header.column.columnDef.meta?.sticky === 'right' && {
                          position: 'sticky',
                          right: 0,
                          zIndex: 10,
                        })
                      }}
                    >
                      {header?.isPlaceholder ? null : (
                        <div
                          key={header.id}
                          aria-hidden="true"
                          {...{
                            className: header.column.getCanSort()
                              ? "cursor-pointer select-none flex items-center justify-center text-center"
                              : "",
                            onClick: header.column.getToggleSortingHandler(),
                          }}
                        >
                          {flexRender(header.column.columnDef.header, header.getContext())}
                          {{
                            asc: <Icon icon="HeroChevronUp" className="ltr:ml-1.5 rtl:mr-1.5" />,
                            desc: <Icon icon="HeroChevronDown" className="ltr:ml-1.5 rtl:mr-1.5" />,
                          }[header.column.getIsSorted()] ?? null}
                        </div>
                      )}
                    </Th>
                  ))}
                </Tr>
              ))}
            </THead>
            <TBody>
              {!isLoading ? (
                Number(pagination?.totalRecords) <= 0 ? (
                  <Tr>
                    <Td className="text-center py-[100px] font-normal text-[30px]" colspan="11">
                      No Record Found
                    </Td>
                  </Tr>
                ) : (
                  table.getRowModel().rows.map((row) => (
                    <Tr key={row.id}>
                      {row.getVisibleCells().map((cell) => (
                        <Td
                          key={cell.id}
                          style={{
                            ...(cell.column.columnDef.meta?.sticky === 'right' && {
                              position: 'sticky',
                              right: 0,
                              zIndex: 10,
                            })
                          }}
                          className={cell.column.columnDef.meta?.sticky === 'right' ? 'shadow-[-4px_0_6px_-2px_rgba(0,0,0,0.3)] !bg-white group-even/Tr:!bg-zinc-100 dark:!bg-[#18181b] dark:group-even/Tr:!bg-[#121214]' : ''}
                        >
                          {flexRender(cell.column.columnDef.cell, cell.getContext())}
                        </Td>
                      ))}
                    </Tr>
                  ))
                )
              ) : (
                [...Array(pagination?.showRecords)].map((_, index) => (
                  <Tr className="bg-gray-100">
                    <TableSkeletonLoader length={11} />
                  </Tr>
                ))
              )}
            </TBody>
            <TFoot>
              {table.getFooterGroups().map((footerGroup) => (
                <Tr key={footerGroup.id}>
                  {footerGroup.headers.map((header) => (
                    <Th
                      key={header.id}
                      isColumnBorder={false}
                      className={`text-left ${header.column.columnDef.meta?.sticky === 'right' ? '!bg-gray-50 dark:!bg-[#09090b] shadow-[-4px_0_6px_-2px_rgba(0,0,0,0.3)]' : ''}`}
                      style={{
                        width: header.getSize(),
                        ...(header.column.columnDef.meta?.sticky === 'right' && {
                          position: 'sticky',
                          right: 0,
                          zIndex: 10,
                        })
                      }}
                    >
                      {header.isPlaceholder ? null : (
                        <div
                          key={header.id}
                          aria-hidden="true"
                          {...{
                            className: header.column.getCanSort()
                              ? "cursor-pointer select-none flex items-center  justify-center"
                              : "",
                            onClick: header.column.getToggleSortingHandler(),
                          }}
                        >
                          {flexRender(header.column.columnDef.header, header.getContext())}
                          {{
                            asc: <Icon icon="HeroChevronUp" className="ltr:ml-1.5 rtl:mr-1.5" />,
                            desc: <Icon icon="HeroChevronDown" className="ltr:ml-1.5 rtl:mr-1.5" />,
                          }[header.column.getIsSorted()] ?? null}
                        </div>
                      )}
                    </Th>
                  ))}
                </Tr>
              ))}
            </TFoot>
          </Table>
        </div>
      </CardBody >
      <TableCardFooterTemplate
        table={table}
        pagination={pagination}
        setPageSize={setPageSize}
        setPageIndex={setPageIndex}
      />

      {/* Edit Machine Model */}

      <RemoveWatchListConfirmationModel
        modalStatus={modalStatus}
        setModalStatus={setModalStatus}
        handleRemoveWatchList={handleRemoveWatchList}
      />
      {
        viewAssetInfo && (
          <ViewAssetInfoModel
            modalStatus={viewAssetInfo}
            setModalStatus={setViewAssetInfo}
            vieAssetInfoID={vieAssetInfoID}
          />
        )
      }
      {/* <AddMachineModel
        handleResetPagination={handleResetPagination}
        handleCloseMachinePopUp={handleCloseMachinePopUp}
        modalStatus={modalStatus}
        setModalStatus={setModalStatus}
        editMachineInfo={editMachineInfo}
      /> */}
    </>
  );
};

export default TablePartial;
